import React from "react";
import HhaCompetency from "../../components/HHA/HhaCompetency";
import RnCompetency from "../../components/RN/RnCompetency";
import LvnCompetency from "../../components/Lvn/LvnCompetency";
import PtCompetency from "../../components/PT/PtCompetency";
import PtaCompetency from "../../components/PTA/PtaCompetency";
import OtCompetency from "../../components/OT/OtCompetency";
import OtaCompetency from "../../components/OTA/OtaCompetency";
import MswCompetency from "../../components/MSW/MswCompetency";
import STCompetency from "../../components/St/STCompetency";

const COMPETENCY_COMPONENTS = {
  hha: HhaCompetency,
  rn: RnCompetency,
  registerednurse: RnCompetency,
  lvn: LvnCompetency,
  licensedvocationalnurse: LvnCompetency,
  pt: PtCompetency,
  physicaltherapist: PtCompetency,
  pta: PtaCompetency,
  physicaltherapistassistant: PtaCompetency,
  ot: OtCompetency,
  occupationaltherapist: OtCompetency,
  ota: OtaCompetency,
  certifiedoccupationaltherapyassistant: OtaCompetency,
  msw: MswCompetency,
  medicalsocialworker: MswCompetency,
  st: STCompetency
};

const CompetencyRenderer = ({ positionId, onClose, ...props }) => {
  // Standardize positionId (e.g., 'RN', 'rn', 'Registered Nurse')
  const normalizedId = positionId?.toLowerCase().replace(/\s+/g, "");

  // Support both direct ID match and role selection
  const Component =
    COMPETENCY_COMPONENTS[normalizedId] || COMPETENCY_COMPONENTS["rn"];

  if (!Component) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto bg-gray-100">
      <Component onClose={onClose} {...props} />
    </div>
  );
};

export default CompetencyRenderer;
